export default __webpack_public_path__ + "static/media/logo_wiki_big_white.9c2fd86c.svg";